import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ServiceStackItem = ({
    title,
    number,
    description,
    tags = [],
    works = [],
    backgroundColor = "bg-base-opp",
    titleClass = "opposite",
    descriptionClass = "t-opposite"
}) => {
    const { t } = useLanguage();
    return (
        <div className="stack-item">
            <div className={`mxd-services-stack__inner showcase-inner ${backgroundColor}`}>
                <div className="mxd-services-stack__title showcase-title">
                    <h3 className={titleClass}>{title}</h3>
                    <span className="mxd-services-stack__number t-opp-muted">/{number}</span>
                </div>
                <div className="mxd-services-stack__info showcase-info">
                    <p className={descriptionClass}>{description}</p>
                </div>
                {works.length > 0 && (
                    <div className="mxd-services-stack__works">
                        {works.map((work, index) => (
                            <a key={index} className="mxd-services-stack__work" href={work.link || "#"}>
                                <img
                                    className="mxd-services-stack__preview"
                                    src={work.image}
                                    alt={work.alt || t('common.alt_texts.work_preview')}
                                />
                                {work.tags && work.tags.length > 0 && (
                                    <div className="mxd-services-stack__tags tags-absolute">
                                        {work.tags.map((tag, tagIndex) => (
                                            <span key={tagIndex} className="tag tag-default tag-permanent">
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                <div className="mxd-preview-hover">
                                    <i className="mxd-preview-hover__icon icon-small">
                                        <img src="img/icons/icon-eye.svg" alt={t('common.alt_texts.eye_icon')} />
                                    </i>
                                </div>
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ServiceStackItem;
